import React from 'react';

const AboutUs = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Hakkımızda</h1>
            <div style={styles.content}>
                <p style={styles.text}>
                    ESAM, kuruluşundan bu yana kaliteli hizmet anlayışı ile sektörde öncü
                    bir konuma sahiptir. Misyonumuz, topluma değer katmak ve sürdürülebilir
                    kalkınmaya katkıda bulunmaktır.
                </p>
                <p style={styles.text}>
                    Deneyimli kadromuz ve modern altyapımızla, müşterilerimize en iyi
                    hizmeti sunmak için çalışmaktayız.
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '3rem 20px',
    },
    title: {
        fontSize: '2.5rem',
        color: '#1e5a96',
        marginBottom: '2rem',
        borderBottom: '3px solid #1e5a96',
        paddingBottom: '1rem',
    },
    content: {
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    text: {
        fontSize: '1.1rem',
        lineHeight: '1.8',
        color: '#555',
        marginBottom: '1rem',
    },
};

export default AboutUs;